import { Col, Modal, Row, Table, Upload } from 'antd';
import { Link, useLocation, useParams } from 'react-router-dom';
import { useMemo } from 'react';
import Helpers from '../../../../../../helpers';
import { Button } from '../../../../../../components';
import {
  DownloadOutlined,
  InfoCircleOutlined,
  UploadOutlined,
} from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import UIHelper from '../../../../../../helpers/UIHelper';
import { useNavigate } from '../../../../../../hooks/useNavigate';

const OldDataModal = ({ data, loading }) => {
  const { pathname } = useLocation();
  const { t } = useTranslation();
  const { id } = useParams();
  const navigate = useNavigate();
  const currentQR = data?.qrs?.find((qr) => qr.company_id === +id);
  const file_logs = currentQR?.file_logs || [];

  const columns = useMemo(() => {
    return [
      {
        title: t('Creato'),
        dataIndex: 'created_at',
        render: (text) => UIHelper.formatedDate(text),
      },
      {
        title: t('Visualizzazioni'),
        dataIndex: 'count_open',
      },
      {
        title: t('Scarica file'),
        dataIndex: 'file',
        render: (data) =>
          data && (
            <Button
              htmlFor='download-file'
              type='primary-white'
              icon={<DownloadOutlined style={{ marginRight: '10px' }} />}
            >
              <a
                id='download-file'
                target='_blank'
                rel='noopener noreferrer'
                href={data}
              >
                {t('Scarica File')}
              </a>
            </Button>
          ),
      },
    ];
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <Modal
      title={currentQR?.title}
      visible={true}
      // onOk={handleOk}
      // onCancel={handleCancel}
      footer={null}
      onCancel={() => navigate(UIHelper.getListRoute(pathname, 1))}
    >
      <Table
        columns={columns}
        dataSource={file_logs}
        pagination={false}
        loading={loading}
        // scroll={{ x: 1500 }}
        // bordered
      />
    </Modal>
  );
};

export default OldDataModal;
